import React, {Component} from "react";
import "./HeroNavigation.css";

import Icon from "Icon/Icon";
import Hyperlink from "Hyperlink/Hyperlink";

export default class HeroNavigation extends Component
{
	render()
	{
		return (
			<nav>
				<ul>
					{/*<li onClick={() => this.props.scrollToSection("Home")}>Home</li>*/}
					<li onClick={() => this.props.scrollToSection("About")}>About</li>
					<li onClick={() => this.props.scrollToSection("Portfolio")}>Portfolio</li>
					<li onClick={() => this.props.scrollToSection("Contact")}>Contact</li>
					<li>
						<Hyperlink href="https://github.com/andrew4699/" newTab>
							<Icon title="GitHub">github</Icon>
						</Hyperlink>
					</li>
				</ul>
			</nav>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Hero/HeroNavigation/HeroNavigation.js